import React from 'react';
import PropTypes from 'prop-types';
import { PieChart as Chart, Pie, ResponsiveContainer, Cell, Label } from 'recharts';

const Gauge = ({ value, label, maxValue, automationId }) => (
  <div className="u-p" data-automation-id={`container:${automationId}`}>
    <ResponsiveContainer height={210}>
      <Chart>
        <Pie
          data={[{ value }, { value: maxValue - value }]}
          startAngle={0}
          endAngle={300}
          innerRadius="80%"
          outerRadius="100%"
          dataKey="value"
          cx="50%"
          cy="50%"
          isAnimationActive={false}
          fill="#e7e8eb"
          stroke="#e7e8eb"
        >
          <Cell fill="#7e8e7f" stroke="#7e8e7f" />
          <Label value={label} offset={0} position="center" />
        </Pie>
      </Chart>
    </ResponsiveContainer>
  </div>
);

Gauge.propTypes = {
  value: PropTypes.number.isRequired,
  label: PropTypes.string,
  maxValue: PropTypes.number,
  automationId: PropTypes.string,
};

Gauge.defaultProps = {
  label: '',
  maxValue: 100,
  automationId: null,
};

export default Gauge;
